import { useParams } from 'react-router-dom'

import { NotFound } from '@factorialco/deprecated-design-system'

import Loading from 'modules/core/components/Loading'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import i18n from 'modules/core/lib/i18n'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import { locale } from 'modules/marketplace/components/utils/locales'
import Content from 'modules/marketplace_modules/components/Content'

import { countryCode } from '../components/utils/countryCode'
import { useGetDatoModules } from '../hooks/useGetDatoModules'

const ModulesDetailTemplate = () => {
  const { id: slug } = useParams()
  const {
    company,
    access: { locale: user_locale },
  } = useCurrentSession()

  const datoFormatLocale = locale[user_locale]
  const countryCodeForCompany = countryCode(company.legalEntities[0]?.country || '')

  const { data: moduleData, loading } = useGetDatoModules({
    locale: datoFormatLocale,
    slug: slug,
    countryCode: countryCodeForCompany,
  })

  if (loading) return <Loading />

  const module = moduleData.at(0)

  if (!module) {
    return (
      <NotFound
        title={i18n.t('errors.page_not_found.title')}
        description={i18n.t('errors.page_not_found.description')}
      />
    )
  }

  return (
    <ResponsivePage.Body showHeader={false}>
      <Content module={module} />
    </ResponsivePage.Body>
  )
}

export default ModulesDetailTemplate
